import { Box } from '@mui/material'
import React from 'react'
import { TableCellProps } from 'react-virtualized'

import Tag from 'src/muiv5/components/commons/Tag'

interface ITagCell extends TableCellProps {
  color?: { background: string; text: string }
  icon?: JSX.Element
  label?: string
  onIconClick?: (data: TableCellProps) => void
}

export function TagCell({ cellData, color, icon, onIconClick, label }: ITagCell) {
  return (
    <Box display="flex">
      <Tag
        icon={
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ color: `${color?.text ?? 'white'} !important` }}
          >
            {icon}
          </Box>
        }
        onClick={() => onIconClick?.(cellData)}
        label={label ?? cellData}
        color={color?.text}
        background={color?.background}
      />
    </Box>
  )
}
